import useSWRImmutable from 'swr';
import { getter, post } from 'core/utils/request';
import urlResolver from 'admin/utils/URLResolver';

export const useExamLock = (classId, examId) => {
  const url = urlResolver.reverse('api:class-exam-lock', {
    classId,
    examId,
  });

  const { data, error, mutate } = useSWRImmutable(url, getter);

  const setIsLocked = async (isLocked) => {
    const options = {
      optimisticData: {
        ...data,
        is_locked: isLocked,
      },
      rollbackOnError: true,
      revalidate: false,
    };

    try {
      await mutate(post(url, { is_locked: isLocked }), options);
    } catch (error) {
      console.error(error); // TODO: notify user of error
    }
  };

  return {
    isLocked: data?.is_locked,
    error,
    loading: !data && !error,
    setIsLocked,
  };
};
